export const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS",
GET_ACCOUNT_START = "GET_ACCOUNT_START",
GET_ACCOUNT_FAIL = "GET_ACCOUNT_FAIL",
RESET_USER_DATA = "RESET_USER_DATA",
UPDATE_PASSWORD = "UPDATE_PASSWORD",
CONFIRM_EMAIL = "CONFIRM_EMAIL";